import { render, staticRenderFns } from "./payment-failed.html?vue&type=template&id=d9221104&scoped=true&external"
import script from "./payment-failed.js?vue&type=script&lang=js&external"
export * from "./payment-failed.js?vue&type=script&lang=js&external"
import style0 from "./payment-failed.scss?vue&type=style&index=0&id=d9221104&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9221104",
  null
  
)

export default component.exports